IntlMessageFormat.__addLocaleData({"locale":"ms","pluralRuleFunction":function (n,ord){if(ord)return n==1?"one":"other";return"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ms-Arab","pluralRuleFunction":function (n,ord){if(ord)return"other";return"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ms-Latn","parentLocale":"ms"});
IntlMessageFormat.__addLocaleData({"locale":"ms-Latn-BN","parentLocale":"ms-Latn"});
IntlMessageFormat.__addLocaleData({"locale":"ms-Latn-MY","parentLocale":"ms-Latn"});
IntlMessageFormat.__addLocaleData({"locale":"ms-Latn-SG","parentLocale":"ms-Latn"});
